import { taxAxios } from '@/utils/taxAxios';

export const getAuthorizeUrl = (params) => {
  return taxAxios.get('/api/dbc/external/taxation/authorizeUrl', { params });
} 
